import { ITrendingWords } from '@/interfaces/search';
import { getMethod } from '@/services/apis/http-server';

export const getTrendingWords = async (
  limit: number,
): Promise<ITrendingWords[] | undefined> => {
  try {
    const response = await getMethod(`client/trending-word?limit=${limit}`);
    return response?.data;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const requestSearch = async (params: {
  keyword: string;
  type_search: string;
  pageIndex: number;
  pageSize: number;
}) => {
  try {
    const response = await getMethod(`client/search`, {
      ...params,
      type_search: encodeURIComponent(params.type_search),
    });
    return response?.data;
  } catch (error) {
    console.error('Error fetching data: ', error);
  }
};
